import DataLayer from '../../../DataLayer';
import paths from '../../../config/local/paths';
import React from 'react';
import { translate } from '../../Internationalization';

const primaryCtaButton = {
	href: paths.conciergeMeetingAppointment,
	id: 'moving_primary',
	labelKey: 'homeowner.pages.concierge.buttons.moving_primary',
};

const secondaryCtaButton = {
	href: paths.conciergeHomeCheckInAppointment,
	id: 'checkup_primary',
	labelKey: 'homeowner.pages.concierge.buttons.checkup_primary',
};

/**
 * @param {string} buttonId
 * @param {string} buttonUrl
 * @returns {void}
 */
function trackCtaClick(buttonId, buttonUrl) {
	DataLayer.add({
		conciergeCtaButton: buttonId,
		conciergeCtaUrl: buttonUrl,
		event: 'homeownerConciergeCtaClick',
	});
}

/**
 * @param {{href: string, id: string, labelKey: string}} ctaButton
 * @returns {JSX.Element}
 */
function renderCtaButton(ctaButton) {
	return (
		<a
			className="button button-outline button-sm w-1/3 justify-center"
			href={ctaButton.href}
			key={ctaButton.id}
			onClick={() => trackCtaClick(ctaButton.id, ctaButton.href)}
			rel="noreferrer noopener"
			target="_blank"
		>
			{translate(ctaButton.labelKey)}
		</a>
	);
}

/**
 * @param {string[]} itemList
 * @param {string} keyPrefix
 * @returns {JSX.Element}
 */
function renderList(itemList, keyPrefix) {
	return (
		<ul className="list-disc pl-6 mb-4">
			{itemList.map((item) => (
				<li className="mb-2" key={`${keyPrefix}-${item}`}>
					{item}
				</li>
			))}
		</ul>
	);
}

/** @returns {JSX.Element} */
export default function MyConcierge() {
	const benefitList = [
		translate('homeowner.pages.concierge.bullets.moving'),
		translate('homeowner.pages.concierge.bullets.utility'),
		translate('homeowner.pages.concierge.bullets.offers'),
		translate('homeowner.pages.concierge.bullets.coordination'),
	];
	const annualCheckList = [
		translate('homeowner.pages.concierge.check_bullets.pricing'),
		translate('homeowner.pages.concierge.check_bullets.needs'),
		translate('homeowner.pages.concierge.check_bullets.programs'),
	];
	const whyList = [
		translate('homeowner.pages.concierge.why_bullets.value'),
		translate('homeowner.pages.concierge.why_bullets.hours'),
		translate('homeowner.pages.concierge.why_bullets.stress'),
		translate('homeowner.pages.concierge.why_bullets.reviews'),
	];

	return (
		<article className="mx-auto max-w-app rich-text">
			<section className="mt-10 mb-8 pb-5 border-b border-grey-300">
				<h1 className="hl-ms-6 mb-4">
					{translate('homeowner.nav.main.concierge')}
				</h1>
				<p className="mb-3">
					{translate('homeowner.pages.concierge.title')}
				</p>
				<p className="mb-4">
					{translate('homeowner.pages.concierge.intro')}
				</p>
				<p>{translate('homeowner.pages.concierge.no_more_calling')}</p>
			</section>

			<section className="mb-8">
				<section className="mb-8">
					<h3 className="mb-2">
						{translate('homeowner.pages.concierge.benefits_title')}
					</h3>
					<p className="mb-3">
						{translate('homeowner.pages.concierge.benefits_lead')}
					</p>
					{renderList(benefitList, 'benefit')}
				</section>

				<section>
					<div className="flex mb-10">
						{renderCtaButton(primaryCtaButton)}
					</div>
					<h3 className="mb-2">
						{translate(
							'homeowner.pages.concierge.more_than_moving_title'
						)}
					</h3>
					<p className="mb-4">
						{translate(
							'homeowner.pages.concierge.more_than_moving_copy'
						)}
					</p>
					<h3 className="mb-2">
						{translate(
							'homeowner.pages.concierge.annual_check_title'
						)}
					</h3>
					<p className="mb-3">
						{translate(
							'homeowner.pages.concierge.annual_check_lead'
						)}
					</p>
					{renderList(annualCheckList, 'annual-check')}
					<p>{translate('homeowner.pages.concierge.tune_up_copy')}</p>
				</section>
			</section>

			<section className="mb-8 pb-5 border-b border-grey-300">
				<div>
					<h3 className="mb-2">
						{translate('homeowner.pages.concierge.why_title')}
					</h3>
					{renderList(whyList, 'why')}
					<h3 className="mb-2">
						{translate('homeowner.pages.concierge.close_title')}
					</h3>
					<p className="mb-3">
						{translate('homeowner.pages.concierge.close_copy')}
					</p>
					<p>
						{translate('homeowner.pages.concierge.close_cta_copy')}
					</p>
					<div className="flex mt-4">
						{renderCtaButton(secondaryCtaButton)}
					</div>
				</div>
			</section>
		</article>
	);
}
